/** Every category and specialism in the fixed taxonomy, in one place. */

import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

import { TAXONOMY } from '@bidtohire/shared';

export function CategoriesPage(): ReactNode {
  const subcategoryCount = TAXONOMY.reduce(
    (sum, category) => sum + category.subcategories.length,
    0,
  );

  return (
    <>
      <div style={{ borderBottom: '1px solid var(--hairline)', background: 'var(--canvas-soft)' }}>
        <div className="inner" style={{ paddingTop: 40, paddingBottom: 36 }}>
          <span className="eyebrow">Categories</span>
          <h1 style={{ marginTop: 10, fontSize: 32 }}>Every board on bidtohire.me</h1>
          <p className="lede" style={{ marginTop: 12, maxWidth: '62ch', fontSize: 16 }}>
            {TAXONOMY.length} categories and {subcategoryCount} specialisms, each with its own
            board. A specialism board is never more expensive to lead than its category.
          </p>
        </div>
      </div>

      <section className="section is-last">
        <div className="inner stack" style={{ gap: 28 }}>
          {TAXONOMY.map((category) => (
            <div key={category.slug}>
              <div
                className="row"
                style={{ justifyContent: 'space-between', alignItems: 'baseline' }}
              >
                <h2 style={{ fontSize: 19 }}>
                  <Link to={`/c/${category.slug}`}>{category.name}</Link>
                </h2>
                <Link className="small" to={`/c/${category.slug}`}>
                  View the {category.name} board →
                </Link>
              </div>
              <div className="chiprow" style={{ marginTop: 12 }}>
                {category.subcategories.map((subcategory) => (
                  <Link
                    key={subcategory.slug}
                    className="chip"
                    to={`/c/${category.slug}/${subcategory.slug}`}
                  >
                    {subcategory.name}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
